export default __webpack_public_path__ + "1510744.png";